export const isFromAdmin = (authToken: any) => {
  return authToken && authToken.length >= 32
}
